var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-code"},[_c('vue-qr',{staticStyle:{"display":"block","margin":"auto"},attrs:{"text":_vm.pcbaUrl,"size":150,"margin":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }